// typography.ts
export const typographyTokens = {
  "typography": {
    "xs": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyXsPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyXsPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "16px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "lineHeight"
          },
          "name": "TypographyXsPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyXsPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "xs",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyXsSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyXsSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "16px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "lineHeight"
          },
          "name": "TypographyXsSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyXsSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "xs",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyXsTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "12px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "12px",
            "type": "dimension"
          },
          "name": "TypographyXsTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyXsTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "16px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "lineHeight"
          },
          "name": "TypographyXsTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyXsTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "xs",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "xs",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "sm": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographySmPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographySmPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "20px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "lineHeight"
          },
          "name": "TypographySmPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographySmPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "sm",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographySmSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographySmSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "20px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "lineHeight"
          },
          "name": "TypographySmSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographySmSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "sm",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographySmTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "14px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "14px",
            "type": "dimension"
          },
          "name": "TypographySmTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographySmTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "20px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "lineHeight"
          },
          "name": "TypographySmTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographySmTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "sm",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "sm",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "base": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyBasePrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "TypographyBasePrimarySize",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "15px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "15px",
            "type": "dimension"
          },
          "name": "TypographyBasePrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "TypographyBasePrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyBasePrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "24px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "lineHeight"
          },
          "name": "TypographyBasePrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyBasePrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "base",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyBaseSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "TypographyBaseSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "15px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "15px",
            "type": "dimension"
          },
          "name": "TypographyBaseSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "TypographyBaseSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyBaseSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "24px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "lineHeight"
          },
          "name": "TypographyBaseSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyBaseSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "base",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyBaseTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "TypographyBaseTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "15px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "15px",
            "type": "dimension"
          },
          "name": "TypographyBaseTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "16px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "16px",
            "type": "dimension"
          },
          "name": "TypographyBaseTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyBaseTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "24px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "lineHeight"
          },
          "name": "TypographyBaseTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyBaseTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "base",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "base",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "lg": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyLgPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyLgPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "17px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "17px",
            "type": "dimension"
          },
          "name": "TypographyLgPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyLgPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyLgPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "28px",
            "type": "lineHeight"
          },
          "name": "TypographyLgPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyLgPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "lg",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyLgSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyLgSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "17px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "17px",
            "type": "dimension"
          },
          "name": "TypographyLgSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyLgSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyLgSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "28px",
            "type": "lineHeight"
          },
          "name": "TypographyLgSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyLgSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "lg",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyLgTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyLgTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "17px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "17px",
            "type": "dimension"
          },
          "name": "TypographyLgTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyLgTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 400,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 400,
            "type": "fontWeight"
          },
          "name": "TypographyLgTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "28px",
            "type": "lineHeight"
          },
          "name": "TypographyLgTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "0",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "0",
            "type": "letterSpacing"
          },
          "name": "TypographyLgTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "lg",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "lg",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "xl": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyXlPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "TypographyXlPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyXlPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "TypographyXlPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 500,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 500,
            "type": "fontWeight"
          },
          "name": "TypographyXlPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "28px",
            "type": "lineHeight"
          },
          "name": "TypographyXlPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-0.5px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-0.5px",
            "type": "letterSpacing"
          },
          "name": "TypographyXlPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "xl",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyXlSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "TypographyXlSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyXlSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "TypographyXlSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 500,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 500,
            "type": "fontWeight"
          },
          "name": "TypographyXlSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "28px",
            "type": "lineHeight"
          },
          "name": "TypographyXlSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-0.5px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-0.5px",
            "type": "letterSpacing"
          },
          "name": "TypographyXlSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "xl",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "TypographyXlTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "TypographyXlTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "18px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "18px",
            "type": "dimension"
          },
          "name": "TypographyXlTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "TypographyXlTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 500,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 500,
            "type": "fontWeight"
          },
          "name": "TypographyXlTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "28px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "28px",
            "type": "lineHeight"
          },
          "name": "TypographyXlTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-0.5px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-0.5px",
            "type": "letterSpacing"
          },
          "name": "TypographyXlTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "xl",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "xl",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "2xl": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography2xlPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "Typography2xlPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "Typography2xlPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "Typography2xlPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 600,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 600,
            "type": "fontWeight"
          },
          "name": "Typography2xlPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "32px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "lineHeight"
          },
          "name": "Typography2xlPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-0.5px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-0.5px",
            "type": "letterSpacing"
          },
          "name": "Typography2xlPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "2xl",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography2xlSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "Typography2xlSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "Typography2xlSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "Typography2xlSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 600,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 600,
            "type": "fontWeight"
          },
          "name": "Typography2xlSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "32px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "lineHeight"
          },
          "name": "Typography2xlSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-0.5px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-0.5px",
            "type": "letterSpacing"
          },
          "name": "Typography2xlSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "2xl",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography2xlTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "Typography2xlTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "20px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "20px",
            "type": "dimension"
          },
          "name": "Typography2xlTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "24px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "24px",
            "type": "dimension"
          },
          "name": "Typography2xlTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 600,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 600,
            "type": "fontWeight"
          },
          "name": "Typography2xlTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "32px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "lineHeight"
          },
          "name": "Typography2xlTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-0.5px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-0.5px",
            "type": "letterSpacing"
          },
          "name": "Typography2xlTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "2xl",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "2xl",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "3xl": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography3xlPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography3xlPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "26px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "26px",
            "type": "dimension"
          },
          "name": "Typography3xlPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography3xlPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 600,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 600,
            "type": "fontWeight"
          },
          "name": "Typography3xlPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "40px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "lineHeight"
          },
          "name": "Typography3xlPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1px",
            "type": "letterSpacing"
          },
          "name": "Typography3xlPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "3xl",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography3xlSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography3xlSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "26px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "26px",
            "type": "dimension"
          },
          "name": "Typography3xlSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography3xlSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 600,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 600,
            "type": "fontWeight"
          },
          "name": "Typography3xlSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "40px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "lineHeight"
          },
          "name": "Typography3xlSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1px",
            "type": "letterSpacing"
          },
          "name": "Typography3xlSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "3xl",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography3xlTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography3xlTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "26px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "26px",
            "type": "dimension"
          },
          "name": "Typography3xlTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography3xlTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 600,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 600,
            "type": "fontWeight"
          },
          "name": "Typography3xlTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "40px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "lineHeight"
          },
          "name": "Typography3xlTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1px",
            "type": "letterSpacing"
          },
          "name": "Typography3xlTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "3xl",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "3xl",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "4xl": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography4xlPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "40px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "dimension"
          },
          "name": "Typography4xlPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography4xlPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "40px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "dimension"
          },
          "name": "Typography4xlPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 700,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 700,
            "type": "fontWeight"
          },
          "name": "Typography4xlPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "48px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "lineHeight"
          },
          "name": "Typography4xlPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1px",
            "type": "letterSpacing"
          },
          "name": "Typography4xlPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "4xl",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography4xlSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "40px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "dimension"
          },
          "name": "Typography4xlSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography4xlSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "40px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "dimension"
          },
          "name": "Typography4xlSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 700,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 700,
            "type": "fontWeight"
          },
          "name": "Typography4xlSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "48px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "lineHeight"
          },
          "name": "Typography4xlSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1px",
            "type": "letterSpacing"
          },
          "name": "Typography4xlSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "4xl",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography4xlTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "40px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "dimension"
          },
          "name": "Typography4xlTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "32px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "32px",
            "type": "dimension"
          },
          "name": "Typography4xlTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "40px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "40px",
            "type": "dimension"
          },
          "name": "Typography4xlTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 700,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 700,
            "type": "fontWeight"
          },
          "name": "Typography4xlTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "48px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "lineHeight"
          },
          "name": "Typography4xlTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1px",
            "type": "letterSpacing"
          },
          "name": "Typography4xlTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "4xl",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "4xl",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    },
    "5xl": {
      "primary": {
        "family": {
          "value": "Lato, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Lato, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography5xlPrimaryFamily",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "family"
          ]
        },
        "size": {
          "value": "48px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "dimension"
          },
          "name": "Typography5xlPrimarySize",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "36px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "36px",
            "type": "dimension"
          },
          "name": "Typography5xlPrimarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "48px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "dimension"
          },
          "name": "Typography5xlPrimarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 700,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 700,
            "type": "fontWeight"
          },
          "name": "Typography5xlPrimaryWeight",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "56px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "56px",
            "type": "lineHeight"
          },
          "name": "Typography5xlPrimaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1.2px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1.2px",
            "type": "letterSpacing"
          },
          "name": "Typography5xlPrimaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "primary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "5xl",
            "primary",
            "letterSpacing"
          ]
        }
      },
      "secondary": {
        "family": {
          "value": "Inter, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Inter, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography5xlSecondaryFamily",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "family"
          ]
        },
        "size": {
          "value": "48px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "dimension"
          },
          "name": "Typography5xlSecondarySize",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "36px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "36px",
            "type": "dimension"
          },
          "name": "Typography5xlSecondarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "48px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "dimension"
          },
          "name": "Typography5xlSecondarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 700,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 700,
            "type": "fontWeight"
          },
          "name": "Typography5xlSecondaryWeight",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "56px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "56px",
            "type": "lineHeight"
          },
          "name": "Typography5xlSecondaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1.2px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1.2px",
            "type": "letterSpacing"
          },
          "name": "Typography5xlSecondaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "secondary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "5xl",
            "secondary",
            "letterSpacing"
          ]
        }
      },
      "tertiary": {
        "family": {
          "value": "Roboto, sans-serif",
          "type": "fontFamily",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "Roboto, sans-serif",
            "type": "fontFamily"
          },
          "name": "Typography5xlTertiaryFamily",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "family"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "family"
          ]
        },
        "size": {
          "value": "48px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "dimension"
          },
          "name": "Typography5xlTertiarySize",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "size"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "size"
          ]
        },
        "sizeMobile": {
          "value": "36px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "36px",
            "type": "dimension"
          },
          "name": "Typography5xlTertiarySizeMobile",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "sizeMobile"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "sizeMobile"
          ]
        },
        "sizeDesktop": {
          "value": "48px",
          "type": "dimension",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "48px",
            "type": "dimension"
          },
          "name": "Typography5xlTertiarySizeDesktop",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "sizeDesktop"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "sizeDesktop"
          ]
        },
        "weight": {
          "value": 700,
          "type": "fontWeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": 700,
            "type": "fontWeight"
          },
          "name": "Typography5xlTertiaryWeight",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "weight"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "weight"
          ]
        },
        "lineHeight": {
          "value": "56px",
          "type": "lineHeight",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "56px",
            "type": "lineHeight"
          },
          "name": "Typography5xlTertiaryLineHeight",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "lineHeight"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "lineHeight"
          ]
        },
        "letterSpacing": {
          "value": "-1.2px",
          "type": "letterSpacing",
          "filePath": "design-tokens/typography.json",
          "isSource": true,
          "original": {
            "value": "-1.2px",
            "type": "letterSpacing"
          },
          "name": "Typography5xlTertiaryLetterSpacing",
          "attributes": {
            "category": "typography",
            "type": "5xl",
            "item": "tertiary",
            "subitem": "letterSpacing"
          },
          "path": [
            "typography",
            "5xl",
            "tertiary",
            "letterSpacing"
          ]
        }
      }
    }
  },
  "fontFamilies": {
    "primary": {
      "value": "Lato, sans-serif",
      "type": "fontFamily",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": "Lato, sans-serif",
        "type": "fontFamily"
      },
      "name": "FontFamiliesPrimary",
      "attributes": {
        "category": "fontFamilies",
        "type": "primary"
      },
      "path": [
        "fontFamilies",
        "primary"
      ]
    },
    "secondary": {
      "value": "Inter, sans-serif",
      "type": "fontFamily",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": "Inter, sans-serif",
        "type": "fontFamily"
      },
      "name": "FontFamiliesSecondary",
      "attributes": {
        "category": "fontFamilies",
        "type": "secondary"
      },
      "path": [
        "fontFamilies",
        "secondary"
      ]
    },
    "tertiary": {
      "value": "Roboto, sans-serif",
      "type": "fontFamily",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": "Roboto, sans-serif",
        "type": "fontFamily"
      },
      "name": "FontFamiliesTertiary",
      "attributes": {
        "category": "fontFamilies",
        "type": "tertiary"
      },
      "path": [
        "fontFamilies",
        "tertiary"
      ]
    }
  },
  "fontWeights": {
    "thin": {
      "value": 100,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 100,
        "type": "fontWeight"
      },
      "name": "FontWeightsThin",
      "attributes": {
        "category": "fontWeights",
        "type": "thin"
      },
      "path": [
        "fontWeights",
        "thin"
      ]
    },
    "light": {
      "value": 300,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 300,
        "type": "fontWeight"
      },
      "name": "FontWeightsLight",
      "attributes": {
        "category": "fontWeights",
        "type": "light"
      },
      "path": [
        "fontWeights",
        "light"
      ]
    },
    "normal": {
      "value": 400,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 400,
        "type": "fontWeight"
      },
      "name": "FontWeightsNormal",
      "attributes": {
        "category": "fontWeights",
        "type": "normal"
      },
      "path": [
        "fontWeights",
        "normal"
      ]
    },
    "medium": {
      "value": 500,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 500,
        "type": "fontWeight"
      },
      "name": "FontWeightsMedium",
      "attributes": {
        "category": "fontWeights",
        "type": "medium"
      },
      "path": [
        "fontWeights",
        "medium"
      ]
    },
    "semibold": {
      "value": 600,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 600,
        "type": "fontWeight"
      },
      "name": "FontWeightsSemibold",
      "attributes": {
        "category": "fontWeights",
        "type": "semibold"
      },
      "path": [
        "fontWeights",
        "semibold"
      ]
    },
    "bold": {
      "value": 700,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 700,
        "type": "fontWeight"
      },
      "name": "FontWeightsBold",
      "attributes": {
        "category": "fontWeights",
        "type": "bold"
      },
      "path": [
        "fontWeights",
        "bold"
      ]
    },
    "extrabold": {
      "value": 800,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 800,
        "type": "fontWeight"
      },
      "name": "FontWeightsExtrabold",
      "attributes": {
        "category": "fontWeights",
        "type": "extrabold"
      },
      "path": [
        "fontWeights",
        "extrabold"
      ]
    },
    "black": {
      "value": 900,
      "type": "fontWeight",
      "filePath": "design-tokens/typography.json",
      "isSource": true,
      "original": {
        "value": 900,
        "type": "fontWeight"
      },
      "name": "FontWeightsBlack",
      "attributes": {
        "category": "fontWeights",
        "type": "black"
      },
      "path": [
        "fontWeights",
        "black"
      ]
    }
  }
} as const;

export type TypographyTokens = typeof typographyTokens;
